
const featuredProductsSwipers = document.querySelectorAll(".featured-products-swiper")

if(featuredProductsSwipers) {
  featuredProductsSwipers.forEach(slider => {
    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: '.featured-products-button-next',
        prevEl: '.featured-products-button-prev',
      },
    })
  })
}